
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/building",
      function () {
        return require("private-next-pages/building/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/building"])
      });
    }
  